import { all } from 'redux-saga/effects';
import chat from './chat';

export const chatSaga = function* root() {
  yield all([chat()]);
};
